import React from 'react';
import { CollageContainer, CollageItem } from './styled';
import { Photo } from '../../../graphql/graphql';

const FIRST_PHOTO = 1;

interface GalleryCollageProps {
  photos: Photo[];
  onOpenGallery: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    photoNumber?: number
  ) => void;
}

export const GalleryCollage: React.FC<GalleryCollageProps> = ({
  photos,
  onOpenGallery
}) => {
  const collagePhotos = photos.slice(0, 3);

  if (collagePhotos.length < 3) {
    return null;
  }

  return (
    <CollageContainer>
      {collagePhotos.map((photo, index) => (
        <CollageItem
          key={index}
          $position={index}
          style={{ backgroundImage: `url(${photo.full})` }}
          onClick={e => onOpenGallery(e, FIRST_PHOTO)}
        />
      ))}
    </CollageContainer>
  );
};
